/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback } from 'react'
import Direcao from '../../../../assets/logos/direcao-square.png'
import { BiNotepad } from 'react-icons/bi'
import { Container, ImageContainer, TextContainer } from './styles'
import { BsFillStarFill } from 'react-icons/bs'
import { useDispatch } from 'react-redux'
import history from '../../../../services/history'
import { changeRecentPath } from '../../../../store/modules/recentView/action'
import { mutate } from 'swr'
import { FAVORITE_COURSE } from 'pages/Subscription/services'

interface FavoriteCourseCardProps {
  _id: string
  name: string
  icon: string
  numberOfModules: number
  subscriptionId: string
}

const FavoriteCourseCard: React.FC<FavoriteCourseCardProps> = ({
  _id,
  name,
  icon,
  numberOfModules,
  subscriptionId,
}) => {
  const dispatch = useDispatch()

  const updateFavorite = useCallback(() => {
    FAVORITE_COURSE(String(_id), 'remove', subscriptionId)
      .then(() => {
        mutate(`/course/favorite-courses/${subscriptionId}`)
      })
      .catch((err) => {
        console.error('ops! ocorreu um erro' + err)
      })
  }, [_id, subscriptionId])

  const FavoriteIcon = useCallback(() => {
    return (
      <span onClick={() => updateFavorite()}>
        <BsFillStarFill size={20} color="#FFD233" />
      </span>
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const redirect = useCallback(
    (_id) => {
      dispatch(changeRecentPath(`/subscription/${window.location.href.split('/').pop()}`))
      history.push(`/course/${_id}`)
    },
    [dispatch]
  )

  return (
    <>
      <Container>
        <div key={`div-${_id}`} onClick={() => redirect(_id)}>
          <ImageContainer>
            <img src={icon ? icon : Direcao} alt={name} />
          </ImageContainer>
        </div>
        <TextContainer onClick={() => redirect(_id)}>
          <h2 key={`h2-${_id}`}>{name}</h2>
          {numberOfModules ? <BiNotepad /> : ''}
          {numberOfModules ? (
            <span key={`span-${_id}`}>
              {numberOfModules} módulo{`${numberOfModules > 1 ? 's' : ''}`}
            </span>
          ) : (
            ''
          )}
        </TextContainer>
        <FavoriteIcon />
      </Container>
    </>
  )
}

export default FavoriteCourseCard
